import {
  StyledCardButton,
  StyledCardWrapper,
  StyledContainer,
  StyledRelevanceWrapper,
  StyledTitle,
} from "./styled";
import { ProgressCard } from "../ProgressCard";
import { InfoCard } from "../InfoCard";
import { EApproveStatus } from "../../types";
import { Outlet } from "react-router-dom";

export const ProjectsTab = () => {
  return (
    <StyledRelevanceWrapper>
      <StyledContainer>
        <ProgressCard
          text="1 / 12 подрядчиков не приняли РД"
          redirectUrl="../projects/relevance"
          title="Актуальность РД"
          progressPercentage={92}
        />

        <StyledTitle>Проекты</StyledTitle>

        <StyledCardWrapper>
          <InfoCard
            lastUpdated="13.07.2022"
            redirectUrl="alximovo"
            status={EApproveStatus.UPDATED}
            title="Алхимово"
            extraContent={
              <StyledCardButton>Смотреть</StyledCardButton>
            }
          />
          <InfoCard
            lastUpdated="05.07.2022"
            redirectUrl="zarechie"
            status={EApproveStatus.ACTUAL}
            title="Заречье"
            extraContent={
              <StyledCardButton>Смотреть</StyledCardButton>
            }
          />
        </StyledCardWrapper>
      </StyledContainer>
      <Outlet />
    </StyledRelevanceWrapper>
  );
};
